<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Connect your Register to Sage Intacct
  </h4>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('exit')"
  ></button>
</div>

<div class="modal-body">
  <app-sage-connect
    (complete)="onComplete($event)"
    (cancel)="onCancel()"
    [registerId]="registerId"
    [entityId]="entityId"
    [companyId]="companyId"
    [companyName]="companyName"
  >
  </app-sage-connect>
</div>
